import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

export const passwordRegex = /^(?=.*[A-Z])(?=.*[a-z]).{8,}$/;

function getPasswordCriteria(password: string) {
  return {
    uppercase: /[A-Z]/.test(password),
    lowercase: /[a-z]/.test(password),
    length: password.length >= 8,
  };
}

interface PasswordStrengthIndicatorProps {
  password: string;
  visible: boolean;
  labels: {
    uppercase: string;
    lowercase: string;
    length: string;
  };
}

const PasswordStrengthIndicator: React.FC<PasswordStrengthIndicatorProps> = ({
  password,
  visible,
  labels,
}) => {
  if (!visible) return null;

  const criteria = getPasswordCriteria(password);

  const items = [
    { met: criteria.uppercase, label: labels.uppercase },
    { met: criteria.lowercase, label: labels.lowercase },
    { met: criteria.length, label: labels.length },
  ];

  return (
    <Stack spacing={1} mt={1} mb={2}>
      {items.map((item) => (
        <Stack key={item.label} direction="row" alignItems="center" spacing={1}>
          <Box
            sx={{
              width: 6,
              height: 6,
              borderRadius: '50%',
              backgroundColor: item.met ? 'green' : 'red',
            }}
          />
          <Typography variant="body2">{item.label}</Typography>
        </Stack>
      ))}
    </Stack>
  );
};

export default PasswordStrengthIndicator;
